import { render, staticRenderFns } from "./PageInvitationsMain.vue?vue&type=template&id=4019c050"
import script from "./PageInvitationsMain.vue?vue&type=script&lang=js"
export * from "./PageInvitationsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports